import {
  IBntModalComponents,
  IBntModalModules,
} from '@binotel-frontend/bnt-common-components';
import type {AuthenticationFlowModal} from '@modals/authentication/authentication-flow.modal';
import type {BreadcrumbsModal} from '@shared/modals/breadcrumbs/breadcrumbs.modal';
import type {DossierSectionsModal} from '@shared/modals/dossier-sections/dossier-sections.modal';

export const MODAL = {
  dossierSections: 'dossier-sections',
  authentication: 'authentication',
  breadcrumbs: 'breadcrumbs',
} as const;

export type TModal = (typeof MODAL)[keyof typeof MODAL];

export interface IOdModal extends IBntModalComponents<TModal> {
  [MODAL.dossierSections]: DossierSectionsModal;
  [MODAL.authentication]: AuthenticationFlowModal;
  [MODAL.breadcrumbs]: BreadcrumbsModal;
}

export const MODALS: IBntModalModules<TModal> = {
  [MODAL.dossierSections]: () =>
    import('@shared/modals/dossier-sections/dossier-sections.modal').then(
      (m) => m.DossierSectionsModal
    ),
  [MODAL.authentication]: () =>
    import('@modals/authentication/authentication-flow.modal').then(
      (m) => m.AuthenticationFlowModal
    ),
  [MODAL.breadcrumbs]: () =>
    import('@shared/modals/breadcrumbs/breadcrumbs.modal').then(
      (m) => m.BreadcrumbsModal
    ),
};
